<template>
	<div
		class="components-side-bar"
		:class="{sideBarClose: !sideBarOpened}"
	>
		<!-- <div class="side-bar-logo">
			<i
				class="iconfont"
				:class="{'icon-xinxiwanglogo': sideBarOpened, 'icon-xinxiwangdichanLOGO': !sideBarOpened}"
			></i>
		</div> -->
		<el-scrollbar
      v-if="flag"
			wrap-class="scrollbar-wrapper"
			class="side-bar-nav"
		>
			<el-menu
        ref="side-menu"
				:show-timeout="200"
				:default-active="$route.path"
				:collapse="isCollapse"
				mode="vertical"
				unique-opened
				background-color="#fff"
				text-color="#666"
				active-text-color="#fff"
				@open="handleOpen"
				@close="handleClose"
				@select="handleSelect"
			>
				<!--如果有选中得子系统，则显示系统导航路由，如果没有选中系统则显示应用列表-->

				<!--显示应用列表-->
				<template v-if="!currentAppCode || $route.path === '/home'">
					<div
						v-for="(app,index) in appSystemList"
						:key="index"
						@click="navClick(app)"
					>
						<!-- <router-link
            v-for="(app,index) in appSystemList"
            :key="index"
            to="partner-manage"
          > -->
						<el-menu-item
							:class="{sideBarclose: !sideBarOpened}"
							:index="app.url"
						>
							<i
								v-if="app.icon"
								class="icon iconfont"
								:class="[app.icon]"
							></i>
							<span slot="title">{{app.name}}</span>
						</el-menu-item>
					</div>
				</template>
				<!--应用导航列表-->
				<template v-else>
					<side-bar-item
						v-for="(nav,index) in navList"
						:key="index"
						:navItem="nav"
						:base-path="nav.route"
					/>
				</template>
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
// 子系统配置文件
import sideBarItem from './side-bar-item'
import { mapState } from 'vuex'

export default {
  components: {
    sideBarItem
  },
  data() {
    return {
      flag:true
    }
  },
  watch:{
    navList:{
      handler(oldVal=[],newVal=[]){
      if(JSON.stringify(oldVal)!==JSON.stringify(newVal)){
        this.flag=false
        let time=(oldVal.length>0&&newVal.length>0)?10:800
      setTimeout(() => {
        this.flag=true
      }, time);
      }
    },
    immediate:true
    },
    "$route":{
      handler(newRoute,oldRoute){
        if(newRoute.meta.toPmplan){
          this.flag=false
          setTimeout(() => {
            this.$router.replace(oldRoute.fullPath)
            this.flag=true
          }, 0);
        }
      }
    }
  },
  computed: {
    ...mapState({
      sideBarOpened: state => state.sideBarOpened,
      appSystemList: state => state.appSystemList,
      currentAppCode: state => state.currentAppCode,
      navList: state => state.navigation.sideBarNav
    }),
    isCollapse() {
      return !this.sideBarOpened
    }
  },
  created() {
	  this.$store.dispatch('updateSideBarNav', this.currentAppCode)
  },
	methods: {
		navClick(item){
      this.$store.dispatch('updateSideBarNav', item.id)
			var reg = new RegExp("^"+ this.$config.originURL);
			if(reg.test(item.url)){
				this.$router.push(item.url.replace(this.$config.originURL + '/#', ''))
			}else{
				window.location.href = item.url;
			}
    },
    handleOpen(index) {
      // console.log('handleOpen', index)
    },
    handleClose(index) {
      // console.log('handleClose', index)
    },
    handleSelect(index, indexPath) {
    }
  }
}
</script>

<style lang="scss" scoped>
// 侧边栏宽度
$side-bar-width: 200px;
.components-side-bar {
  background: $side-bar-background-color;
  width: $side-bar-width;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  transition: all $transition-time;
  height: 100%;
  &.sideBarClose {
    width: 60px;
    // .side-bar-logo .iconfont {
    //   font-size: 28px;
    // }
  }

  ::v-deep .el-submenu {
    position: relative;
  }

  ::v-deep .el-menu-item:hover, .el-menu-item:focus{
    background-color: #eef7f7;
    color: $primary;
  }

  ::v-deep .el-menu-item {
    height: 40px;
    line-height: 40px;
    &:hover {
      color: $primary!important;
      background-color: #eef7f7!important;
    }
  }

  ::v-deep .el-submenu__title {
    height: 40px;
    line-height: 40px;
    &:hover {
      color: $primary!important;
      background-color: #eef7f7!important;
    }
  }

  ::v-deep .el-submenu .el-menu-item {
    height: 40px;
    line-height: 40px;

    &:hover {
      color: $primary!important;
      background-color: #eef7f7!important;
    }
  }

  ::v-deep .el-menu-item.is-active {
    background-color: $primary!important;

    &:hover {
      color: #fff!important;
      background-color: $primary!important;;
    }
  }
}

.side-bar-logo {
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: $primary;
}

.side-bar-nav {
  flex: 1;
}
</style>
<style lang="scss" scoped>
.components-side-bar .scrollbar-wrapper {
  overflow-x: hidden;
}

// .el-scrollbar__bar .is-horizontal {
//   .el-scrollbar__thumb {
//     cursor: pointer;
//   }
// }

.el-scrollbar__wrap{
  overflow-x: auto;
  height: calc(100% + 20px); //多出来的20px是横向滚动条默认的样式
}

::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
  min-width: 200px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}

.el-menu {
  border-right: none !important;
  & .el-menu-item:hover {
    color: $primary !important;
  }
  & .el-menu-item.is-active {
    color: $primary !important;
  }
}
</style>
